var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffCompliance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3269 8.60458C13.3269 11.9948 10.9944 13.6899 8.22208 14.6731C8.0769 14.7231 7.91921 14.7207 7.77557 14.6663C4.99656 13.6899 2.66406 11.9948 2.66406 8.60458V3.85826C2.66406 3.48379 2.96243 3.18022 3.33049 3.18022C4.66335 3.18022 6.32942 2.36657 7.48901 1.33594C7.78068 1.08239 8.2103 1.08239 8.50198 1.33594C9.66823 2.37335 11.3276 3.18022 12.6605 3.18022C13.0285 3.18022 13.3269 3.48379 13.3269 3.85826V8.60458Z",
    stroke: "#0C66E4",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffCompliance);
export default __webpack_public_path__ + "static/media/staffCompliance.d48cd93ae7dc2d9ea6ec05f53bd5e2f2.svg";
export { ForwardRef as ReactComponent };